const tableSortHandle = {
    props: {
        value: String,
        propAttr: String,
        order: String,
        currentPage: {
            type: Number,
            default: 1
        },
        pageCount: {
            type: Number,
            default: 1
        }
    },
    data() {
        return {
            search: ''
        }
    },
    components: {
        tablePagination: () => import('@/components/center/table-pagination')
    },
    watch: {
        value: {
            handler: function(value){
                this.search = value;
            },
            immediate: true
        }
    },
    methods: {
        handleInput(value){
            this.$emit('input', value);
        },
        handleSearch(search){
            this.$emit('handleSearch', search);
        },
        handleSelectionChange(rows) {
            this.$emit('selection-change', rows);
        },
        handleBatchDel() {
            this.$emit('batch-del')
        },
        handleTableSort({ column, prop, order }){ // 表格排序方法
            this.$emit('handleSort', { column, prop, order });
        },
        handleCurrent(current){
            this.$emit('current-change', current);
        },
        handleModify(id){
            this.$emit('handleModify', id)
        }
    }
}

const tableRouterView = {
    data() {
        let {
            search = '',
            sortAttr = '',
            sortMode = ''
        } = this.$route.query;
        return {
            search,
            sortAttr,
            sortMode,
            addForm: 0,
            editForm: 0,
            selectedList: []
        }
    },
    methods: {
        handleSearch(search){
            this.search = search;
            this.changeRouter(search, this.sortAttr, this.sortMode);
        },
        handleSelectionChange(rows) {
            this.selectedList = rows;
			console.log(this.selectedList)
        },
        handleSort({ column, prop, order }){
            this.sortAttr = prop;
            this.sortMode = order;
            this.changeRouter(this.search, prop, order);
        },
        handleCurrent(current){
            this.changeRouter(this.search, this.sortAttr, this.sortMode, current)
        }
    },
}

function $debounce(fn, delay = 200) {
    let timer = null;
    return function() {
        let args = arguments;
        if(timer) clearTimeout(timer);

        timer = setTimeout(() => {
            timer = null;
            fn.apply(this, args);
        }, delay)
    }
}

export {
    tableSortHandle,
    tableRouterView,
    $debounce
}